import { TagDescription } from '@reduxjs/toolkit/dist/query/endpointDefinitions';
import { util } from '../../app/api';
import { CHUNK_SIZE } from './uploader.consts';
import { requestRawProcessing } from '../images/images.api';

export interface Upload {
  _id: string;
  file: File;
  error?: string;
  destination: string;
  cloudDestination?: string;
  status: UploadStatus;
  processedChunks: number;
  onComplete?: IUploadCompleteAction[];
}
export interface StoredUpload extends Omit<Upload, 'file'> {
  file: string;
  filename: string;
}

export enum UploadStatus {
  Pending = 'pending',
  Uploading = 'uploading',
  Complete = 'complete',
  Error = 'error',
}

export const getNextChunk = (
  upload: Upload
): {
  chunk: Blob;
  totalChunks: number;
  chunkIndex: number;
  chunkOffest: number;
  fileSize: number;
  chunkSize: number;
} => {
  const start = (upload?.processedChunks ?? 0) * CHUNK_SIZE;
  const end = start + CHUNK_SIZE;
  const chunk = upload.file.slice(start, end);
  return {
    chunk,
    totalChunks: Math.ceil(upload.file.size / CHUNK_SIZE),
    chunkIndex: start / CHUNK_SIZE,
    chunkOffest: start,
    chunkSize: chunk.size,
    fileSize: upload.file.size,
  };
};

export interface IUploadCompleteAction {
  action: 'invalidateTags' | 'requestRawImageProcess';
  args: string[];
}

export const processCompletionActions = (upload: Upload, dispatch: any) => {
  if (upload.onComplete) {
    upload.onComplete.forEach((action) => {
      switch (action.action) {
        case 'requestRawImageProcess':
          dispatch(
            requestRawProcessing.initiate({
              filename: action.args[1],
              albumId: action.args[0],
            })
          );
          setTimeout(() => {
            dispatch(util.invalidateTags(['Images']));
          }, 2000);
          break;
        case 'invalidateTags':
          dispatch(
            util.invalidateTags(
              action.args as TagDescription<
                | 'Enquiries'
                | 'Products'
                | 'SiteSettings'
                | 'Orders'
                | 'Events'
                | 'Users'
                | 'Tasks'
                | 'Albums'
                | 'Images'
                | 'EventCover'
                | 'AlbumCover'
                | 'Archives'
                | 'Watermark'
                | 'Coupons'
                | 'OrderSummaries'
                | 'OrderTotals'
                | 'EventTurnover'
              >[]
            )
          );
          break;
      }
    });
  }
};
